import { LANGUAGES, type LanguageCode } from '@/constants/languages';
import { useLanguageStore } from '@/stores/language-store';

export function resolveIntlLocale(languageCode?: LanguageCode): string {
  const code = languageCode ?? useLanguageStore.getState().locale;
  return LANGUAGES[code]?.locale ?? 'es-AR';
}
